import { useNavigate } from 'react-router-dom';
import { Button } from 'antd';
import classes from './index.module.css';

const BANNER_TEXT = 'Upgrade to On-time  Delivery Guarantee and turn late deliveries into repeat customers.';

export default function OnTimeBanner() {
  const navigate = useNavigate();
  const handleClick = () => {
    navigate('/odg/application/processing-time');
  };
  return (
    <div className={classes.banner} onClick={handleClick}>
      <div className={classes.banner_tips}>
        {BANNER_TEXT}
      </div>
      <Button>Upgrade now →</Button>
    </div>
  );
}
